import React from 'react';
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import connect from "react-redux/es/connect/connect";
import {
    getAutoclaveHistoricoIndicadores,
    getAutoclaves,
    getOSPorEtapaMaquinaCiclo
} from "../../../actions/autoclaveActions";
import {withStyles} from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import {Label} from "@material-ui/icons";
import {Typography} from "@material-ui/core";
import { format } from 'date-fns-tz';
import * as ptBR from 'date-fns/locale/pt-BR'


const ReactHighcharts = require('react-highcharts');
//var Moment = require('moment-timezone');
//require('moment/locale/pt-br');

class AutoclaveCicloGraficoIndicadores extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state={
            renderizado : false,
            listaDataHora: false
        };
        this.listaDataHoraChange = this.listaDataHoraChange.bind(this);
    };


    componentDidMount(){
        //   this.props.getItensManual();

    }

    componentDidUpdate(oldProps, oldState){

       // console.log('didUpdate')

    }

    listaDataHoraChange(){
        this.setState({listaDataHora : !this.state.listaDataHora });
    }


    render() {
        const { autoclaveId, cicloId } = this.props;
        const { ciclosDados } = this.props.autoclaves;

        const { isOpen } = this.state;

      //   console.log("CICLOSDADOS", autoclaveId, ciclosDados);

        let ixseries = ciclosDados.findIndex( (c) => parseInt( c.autoclaveId) === parseInt(autoclaveId) && c.ciclo.toString() === cicloId.toString());

        let series = {
            localDTUtc: [],
            DTUtc: [],
            categoria:[],
            temperatura: [],
            pressao: [],
            envelope: [],
            sacoDeAr: [],
            numAtualizacao: 0,
            autoclaveId: autoclaveId,
            ciclo: cicloId
        }
      //  console.log("IXSERIES", ixseries, autoclaveId, cicloId);
        if (ixseries>=0) {
            series = {
                ...series,
                ...ciclosDados[ixseries].AutoclaveCicloIndicadores
            };

            if (series.DTUtc) {
                // console.log("series dtutc pre", series.DTUtc);
               series.DTUtc.map((d, ix) => {
                   series.localDTUtc.push(    format(new Date(d),'dd/MM/yyyy HH:mm:ss',{localize: ptBR})) // new Date(d).toISOString();
               })
            } else {
                console.log("series", series);
            }
        }

        // console.log("SERIES", series);

        var chartdata = {
            chart: {
                type: 'line',
                zoomType: 'x',
                animation: false
            },
            legend: {
                enabled : true
            },
            title: {
                text: ''
            },
            plotOptions: {
                line: {
                    turboThreshold: 0,
                    marker: {
                        enabled: true,
                        radius: 2
                    }
                }
            },
            xAxis: {
                categories: this.state.listaDataHora? series.localDTUtc : series.categoria,
                title: {
                    text: 'Processo de vulcanização'
                }
            },
            yAxis: [
                {
                    min: -10,
                    max: 180,
                    startOnTick: false,
                    endOnTick: false,
                    title: {
                        text : 'Pressão'
                    }
                },
                {
                    min: -10,
                    max: 180,
                    startOnTick: false,
                    endOnTick: false,
                    title: {
                        text : 'Temperatura'
                    },
                    opposite: true
                }],
            series : [
                {
                    yAxis:1,
                    name : 'Temperatura',
                    data : series.temperatura
                },
                {
                    name : 'Pressão Autoclave',
                    data : series.pressao
                },
                {
                    name : 'Pressão Envelope',
                    data : series.envelope
                },

                {
                    name :  'Pressão Saco Ar',
                    data : series.sacoDeAr
                }

            ]
        }


        return (
            <React.Fragment>
                <FormControlLabel
                    control={
                        <Switch
                            checked={this.state.listaDataHora}
                            onChange={this.listaDataHoraChange}
                            name="listaDataHora"
                            color="primary"
                        />
                    }
                    label="Mostrar Data e Hora no eixo X"
                />
                <ReactHighcharts config = {chartdata} styles={{ height: '100%' }} ></ReactHighcharts>

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {

        autoclaves: state.autoclaves

    }
}

export default  connect(mapStateToProps, { })(AutoclaveCicloGraficoIndicadores)

